var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEsports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Video-Game-Controller-Team--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Video Game Controller Team Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.5h-15a4 4 0 0 0 -4 4v8.92A1.59 1.59 0 0 0 2.12 24C4 24 6 19.49 6 19.49A3 3 0 0 1 8.59 18h6.82A3 3 0 0 1 18 19.48S20 24 21.86 24a1.63 1.63 0 0 0 1.64 -1.62V13.5a4 4 0 0 0 -4 -4ZM7.5 15h-0.75a0.5 0.5 0 0 0 -0.5 0.5v0.75a0.75 0.75 0 0 1 -1.5 0v-0.75a0.5 0.5 0 0 0 -0.5 -0.5H3.5a0.75 0.75 0 0 1 0 -1.5h0.75a0.5 0.5 0 0 0 0.5 -0.5v-0.75a0.75 0.75 0 0 1 1.5 0V13a0.5 0.5 0 0 0 0.5 0.5h0.75a0.75 0.75 0 0 1 0 1.5Zm8.5 0a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm2.5 2a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm0 -4a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm2.5 2a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3 2.2a2.2 2.2 0 1 0 4.4 0 2.2 2.2 0 1 0 -4.4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31 8a0.5 0.5 0 0 0 0.42 -0.23 0.51 0.51 0 0 0 0 -0.48 3.59 3.59 0 0 0 -6.52 0 0.51 0.51 0 0 0 0 0.48 0.52 0.52 0 0 0 0.48 0.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3 2.2a2.2 2.2 0 1 0 4.4 0 2.2 2.2 0 1 0 -4.4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.76 7.28a3.59 3.59 0 0 0 -6.52 0 0.49 0.49 0 0 0 0 0.47 0.48 0.48 0 0 0 0.42 0.23h5.62a0.49 0.49 0 0 0 0.42 -0.23 0.51 0.51 0 0 0 0.06 -0.47Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8 2.2a2.2 2.2 0 1 0 4.4 0 2.2 2.2 0 1 0 -4.4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19 8h5.62a0.48 0.48 0 0 0 0.42 -0.23 0.51 0.51 0 0 0 0 -0.48 3.59 3.59 0 0 0 -6.52 0 0.49 0.49 0 0 0 0 0.47 0.48 0.48 0 0 0 0.48 0.24Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEsports);
export default ForwardRef;